import { render, staticRenderFns } from "./QnaPage.vue?vue&type=template&id=149d3138&"
import script from "./QnaPage.vue?vue&type=script&lang=js&"
export * from "./QnaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports